import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=7f83978d&scoped=true"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=7f83978d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f83978d",
  null
  
)

export default component.exports